import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router';
import { Dimmer, Loader, Button, Icon, Accordion, Popup, Modal } from 'semantic-ui-react';
import queryString from 'query-string';

import SignUpComponent from '../../components/signUpComponent';
import * as Authentication from '../../../services/Authentication';
import * as Database from '../../../services/db';

import './style.less';
import UserContext from '../../../contexts/UserContext';
import RedirectContext from '../../../contexts/RedirectContext';
import StepWizard from 'react-step-wizard';
import CreateMessageRecipient from '../createMessageRecipient';
import { toast } from 'react-toastify';
import ReactPlayer from 'react-player/vimeo';
import { getOrderById, associateReceiptWithUser } from '../../../services/orders';

const Signup = ({ credentials, setCredentials, ...props }) => {
    const { userObject, reloadRegistrantLists } = useContext(UserContext);
    const [loading, setLoading] = useState(true);
    const queryParams = queryString.parse(props.location.search);
    const [contact, setContact] = useState('');

    useEffect(() => {
        const orderId = queryParams.orderId
            ? Array.isArray(queryParams.orderId)
                ? queryParams.orderId[0]
                : queryParams.orderId
            : '';
        console.log('here', Date.now(), orderId);
        if (orderId) {
            // here call the api with the orderId
            // set the contact
            // set loading false
            getOrderById(orderId).then((res) => {
                console.log('res', res);
                if (res && res.contact) {
                    if (res.isExistingUser) {
                        toast.success('You already have an account, redirecting to login!', {
                            position: 'bottom-center',
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                        });

                        props.history.push({
                            pathname: '/login',
                            state: {
                                contact: res.contact,
                            },
                        });
                    } else {
                        setContact(res.contact);
                        setLoading(false);
                    }
                }
                return setLoading(false);
            });
        } else {
            setLoading(false);
        }
    }, []);

    // here get the orderId
    // we wait for the loading,
    // if the orderId does not exist,
    return loading ? (
        <></>
    ) : (
        <div className="signup-page-wrapper">
            <StepWizard onStepChange={(a) => {}} initialStep={userObject.profile ? 2 : 1}>
                <First
                    location={props.location}
                    contact={contact}
                    setCredentials={(contact, password) => {
                        setCredentials({ contact, password });
                    }}
                ></First>
                <Second location={props.location} orderContact={contact}></Second>
                <Third location={props.location}></Third>
                <Fourth
                    location={props.location}
                    credentials={credentials}
                    reloadRegistrantLists={reloadRegistrantLists}
                ></Fourth>
            </StepWizard>
        </div>
    );
};

const PrintInstructions = () => {
    return (
        <div className="info info-grey">
            <div className="icon-section">
                <img className="icon-img" src="./print-instructions.png" alt="" />
            </div>
            <a
                href="https://www.speak2family.com/wp-content/uploads/2021/01/set-up-instructions.pdf"
                target="_blank"
            >
                <h3 className="info-title" role="link">
                    Print Instructions
                </h3>
            </a>
        </div>
    );
};

const ScheduleCall = () => {
    return (
        <div className="info info-grey">
            <div className="icon-section">
                <img className="icon-img" src="./schedule-call.png" alt="" />
            </div>
            <a href="https://email.speak2family.com/meetings/speak2matt/support-call-for-speak2-family" target="_blank">
                <h3 className="info-title">Schedule a Call</h3>
            </a>
        </div>
    );
};

const callAppleHandler = (email, password) => {
    try {
        // @ts-ignore
        window.webkit.messageHandlers.observer.postMessage({
            email,
            password,
        });
    } catch (err) {
        console.log('not really apple');
    }
};

const callAndroidHandler = (email, password) => {
    try {
        //@ts-ignore
        window.Speak2AndroidJSInterface.handleLogin(email, password);
    } catch (err) {
        console.log('not android');
    }
};

const First = (props) => {
    const queryParams = queryString.parse(props.location.search);

    const [firstName, setFirstName] = useState<string>('');
    const [lastName, setLastName] = useState<string>('');
    const [code, setCode] = useState<string>(
        queryParams.token ? (Array.isArray(queryParams.token) ? queryParams.token[0] : queryParams.token) : '',
    );

    const contact =
        props.contact ||
        (queryParams.receivedContact
            ? Array.isArray(queryParams.receivedContact)
                ? queryParams.receivedContact[0]
                : queryParams.receivedContact
            : '');
    const [appOrderId, setAppOrderId] = useState<string>(
        queryParams.order_id
            ? Array.isArray(queryParams.order_id)
                ? queryParams.order_id[0]
                : queryParams.order_id
            : '',
    );
    const showCodeInput = queryParams.token ? true : false;
    const [loading, setLoading] = useState<boolean>(false);
    const [signUpError, setSignUpError] = useState<string>('');
    const disabledButton = queryParams.signup ? true : false;

    const { setUser } = useContext(UserContext);
    const toggleRedirect = useContext(RedirectContext);

    const [accordianIndex, setAccordianIndex] = useState(window.innerWidth > 600 ? 1 : -1);

    const handleClick = (e, titleProps) => {
        const { index } = titleProps;
        const newIndex = accordianIndex === index ? -1 : index;
        setAccordianIndex(newIndex);
    };

    const handleLoginSubmit = async (
        e: React.MouseEvent<HTMLDivElement, MouseEvent>,
        username: string,
        password: string,
        newSignup: boolean = false,
    ): Promise<void> => {
        e.preventDefault();

        setLoading(true);

        try {
            const user = await Authentication.cognitoSignIn(username, password);
            const dbUserProfileResponse = await Database.getUserDbProfile();
            const userProfile = dbUserProfileResponse.userProfile;

            const connectedRegistrants = await Database.getRelatedRegistrants();

            const signedInUser = {
                cognitoUser: user,
                profile: userProfile,
                registrants: {
                    list: connectedRegistrants.residents,
                    activeRegistrantsIndexes:
                        connectedRegistrants.residents && connectedRegistrants.residents.length ? [0] : [],
                },
                username: user.username,
                authenticated: true,
            };

            if (!userProfile) throw Error('No user profile');
            setUser(signedInUser);
            if (newSignup && connectedRegistrants.residents && connectedRegistrants.residents.length === 0) {
                //toggleRedirect('/message-recipients');
            } else {
                //toggleRedirect('/activities');
            }
            return;
        } catch (error) {
            setLoading(false);
            toast.error('Unable to log in.', {
                position: 'bottom-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });
        }
    };

    const handleSignUpSubmit = async (
        e: React.MouseEvent<HTMLDivElement, MouseEvent>,
        contact: string,
        password: string,
    ): Promise<any> => {
        e.preventDefault();

        setLoading(true);

        // if (!token || !registrantId || !receivedContact) {
        //     setSignUpError('Unauthorized registration attempt');
        // }
        if (password.length < 6) {
            setLoading(false);
            toast.error('Password should be at least 6 characters long', {
                position: 'bottom-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });
            return;
        }

        const signUpParams = { password, firstName, lastName };

        if (code) {
            // @ts-ignore
            signUpParams.token = code;
        }

        // @ts-ignore
        signUpParams.contact = contact;

        try {
            await Authentication.cognitoSignUp(signUpParams);

            await props.setCredentials(contact, password);

            try {
                await handleLoginSubmit(e, contact, password, true);
            } catch (error) {
                console.log(error.message);
                throw new Error('Login error');
            }

            if (appOrderId) {
                await associateReceiptWithUser(appOrderId);
            }

            toast.success('Signed up successfully', {
                position: 'bottom-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });
            // @ts-ignore
            if (signUpParams.token) {
                toggleRedirect('/');
            } else {
                props.nextStep();
            }
            return;
        } catch (error) {
            console.log(error.message);
            if (error.message.search('409')) {
                setSignUpError('This user ID is already registered');
            } else if (error.message === 'Login error') {
                setSignUpError('Unable to log in after signing up. Please go to the login page and try again');
            } else {
                setSignUpError('Unable to sign up user');
            }
            setLoading(false);
        }
    };

    const imageSection = () => {
        return (
            <div className="flex flex-justify-center">
                <div className="image-container">
                    <img className="admin-signup-img" src="./admin-account.png" alt="" />
                    <Popup
                        trigger={<Icon name="question circle" className="question-icon" />}
                        position="bottom center"
                        hoverable
                        flowing
                    >
                        <div className="signup-popup-content">
                            <p>
                                Create a new Account. Enter your Name, Email or Phone, and create your password. This is YOUR account, not the Alexa User. Your email or phone will become your user ID.
                            </p>{' '}
                            <p>
                                That's it. You're now an admin, so you can officially start managing the account for the person(s) using an Alexa to communicate. Time to move on to step 2!
                            </p>
                        </div>
                    </Popup>
                </div>
            </div>
        );
    };

    return (
        <div>
            <div className="header step-1">SIGNING UP FOR SPEAK2 FAMILY IS EASY</div>
            <div className="content">
                <div className="content-row">
                    <div className="">
                        <div className="info">
                            <div className="icon-section">
                                <span className="item-number circle">1</span>
                            </div>
                            <div>
                                <h3 className="info-title">Fill in your information to create your Admin account</h3>
                                {window.innerWidth < 600 && imageSection()}
                            </div>
                        </div>

                        <Accordion>
                            <Accordion.Title active={accordianIndex === 1} index={1} onClick={handleClick}>
                                <Icon name="dropdown" />
                                Help
                            </Accordion.Title>
                            <Accordion.Content active={accordianIndex === 1}>
                                <div className="info ">
                                    <div className="icon-section"></div>
                                    <div className="embed-container">
                                        <ReactPlayer
                                            url="https://vimeo.com/462439943"
                                            config={{
                                                vimeo: {
                                                    playerOptions: {
                                                        id: '462439943',
                                                        controls: true,
                                                    },
                                                },
                                            }}
                                        ></ReactPlayer>
                                    </div>
                                </div>
                                <ScheduleCall />
                                <PrintInstructions />
                            </Accordion.Content>
                        </Accordion>
                    </div>
                    <div className="signup-column">
                        <Dimmer active={loading} inverted>
                            <Loader active={loading} />
                        </Dimmer>
                        <div className="mt1">
                            <SignUpComponent
                                firstName={firstName}
                                lastName={lastName}
                                setFirstName={setFirstName}
                                setLastName={setLastName}
                                code={code}
                                setCode={setCode}
                                contact={contact}
                                contactDisabled={props.contact ? true : false}
                                showCodeInput={showCodeInput}
                                handleSignUpSubmit={handleSignUpSubmit}
                                error={signUpError}
                                disabledButton={disabledButton}
                            />
                            <div className="mt1">
                                <b>
                                    Already have an account? <a href="/login">Login here</a>
                                </b>
                            </div>
                        </div>
                    </div>
                    <div className="image-column">{window.innerWidth > 600 && imageSection()}</div>
                </div>
            </div>
        </div>
    );
};

const Second = (props) => {
    const [success, setIsSuccess] = useState(null);

    const [accordianIndex, setAccordianIndex] = useState(window.innerWidth > 600 ? 1 : -1);
    console.log(props.orderContact, 'oc');
    const { userObject, setUser } = useContext(UserContext);
    const queryParams = queryString.parse(props.location.search);

    const [contact, setContact] = useState(
        props.orderContact || queryParams.receivedContact
            ? Array.isArray(queryParams.receivedContact)
                ? queryParams.receivedContact[0]
                : queryParams.receivedContact
            : '',
    );

    useEffect(() => {
        if (props.orderContact) {
            setContact(props.orderContact);
        }
    }, [props.orderContact]);

    const [showAlert, setShowAlert] = useState(false);

    const handleClick = (e, titleProps) => {
        const { index } = titleProps;
        const newIndex = accordianIndex === index ? -1 : index;
        setAccordianIndex(newIndex);
    };

    const handleLogout = async () => {
        try {
            await Authentication.cognitoSignOut();
            setShowAlert(false);

            const signedOutUser = {
                authenticatedUser: undefined,
                profile: undefined,
                authenticated: false,
            };
            setUser(signedOutUser);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (success === true) {
            props.nextStep();
        }
    }, [success]);

    useEffect(() => {
        if (
            userObject &&
            userObject.cognitoUser &&
            userObject.cognitoUser.username &&
            contact &&
            contact !== userObject.cognitoUser.username
        ) {
            setShowAlert(true);
        }
    }, [userObject, contact]);

    const imageSection = () => {
        return (
            <div className="flex flex-justify-center">
                <div className="image-container">
                    <img className="admin-signup-img alexa-user-img" src="./alexa-user-account.png" alt="" />
                    <Popup
                        trigger={<Icon name="question circle" className="question-icon" />}
                        position="bottom center"
                        hoverable
                        flowing
                    >
                        <div className="signup-popup-content">
                            <p>
                                Step 2 creates a user ID and password for the Alexa User. This can be a friend, parent,
                                someone in your community - this is the person who will be using Alexa to ask for help,
                                send messages, or record activities. This part is easy - enter their name and create a
                                user name and password. The user name and password will be used to connect Speak2 to
                                their Alexa in the next step, so be sure to write it down.
                            </p>
                        </div>
                    </Popup>
                </div>
            </div>
        );
    };

    return (
        <div>
            <Modal size={'small'} open={showAlert} onClose={() => setShowAlert(false)}>
                <Modal.Content>
                    You are already logged in as <b>{userObject.cognitoUser && userObject.cognitoUser.username}.</b>{' '}
                    <br /> <br />
                    If you want to create a new account with <b>{contact}</b> please{' '}
                    <Button onClick={handleLogout} size="small" primary className="log-out-btn" basic>
                        log out
                    </Button>
                    and open the invite link again. <br /> <br />
                    Or if you want to connect to the invited resident please go to the invites section and add the
                    invite code{' '}
                    <b>
                        {queryParams.token
                            ? Array.isArray(queryParams.token)
                                ? queryParams.token[0]
                                : queryParams.token
                            : ''}
                    </b>
                </Modal.Content>
            </Modal>
            <div className="header step-2">NOW CREATE YOUR ALEXA USER ACCOUNT</div>
            <div className="content">
                <div className="content-row">
                    <div className="">
                        <div className="info">
                            <div className="icon-section">
                                <span className="item-number circle">2</span>
                            </div>
                            <div>
                                <h3 className="info-title">
                                    This is for the person(or people) who will be using an Alexa to communicate with you
                                    and others
                                </h3>
                                {window.innerWidth < 600 && imageSection()}
                            </div>
                        </div>

                        <Accordion>
                            <Accordion.Title active={accordianIndex === 1} index={1} onClick={handleClick}>
                                <Icon name="dropdown" />
                                Help
                            </Accordion.Title>
                            <Accordion.Content active={accordianIndex === 1}>
                                <div className="info ">
                                    <div className="icon-section"></div>
                                    <div className="embed-container">
                                        <ReactPlayer
                                            url="https://vimeo.com/462442930"
                                            config={{
                                                vimeo: {
                                                    playerOptions: {
                                                        id: '462442930',
                                                        controls: true,
                                                    },
                                                },
                                            }}
                                        ></ReactPlayer>
                                    </div>
                                </div>
                                <ScheduleCall />
                                <PrintInstructions />
                            </Accordion.Content>
                        </Accordion>
                    </div>
                    <div>
                        <CreateMessageRecipient location={props.location} variant="partial" onSuccess={setIsSuccess} />
                    </div>
                    <div className="image-column">{window.innerWidth > 600 && imageSection()}</div>
                </div>
            </div>
        </div>
    );
};

const Third = (props) => {
    const [accordianIndex, setAccordianIndex] = useState(window.innerWidth > 600 ? 1 : -1);

    const handleClick = (e, titleProps) => {
        const { index } = titleProps;
        const newIndex = accordianIndex === index ? -1 : index;
        setAccordianIndex(newIndex);
    };

    const imageSection = () => {
        return (
            <div className="flex flex-justify-center">
                <div className="image-container step-3-image-container">
                    <h4>1.Click this link</h4>
                    <p className="click-link-container">
                        <img className="step-3-arrow" alt="arrow" src="./arrow.jpg"></img>

                        <a href="https://www.amazon.com/Speak2-Software-Family/dp/B085DP2587" target="_blank">
                            https://www.amazon.com/Speak2-Software-Family/dp/B085DP2587
                        </a>
                    </p>
                    <h4>2.Sign into Amazon with the account you used to set up the Alexa</h4>
                    <p>
                        <img className="step-3-img" alt="arrow" src="./sign-in-amazon.jpg"></img>
                    </p>
                    <h4>3.Click “Enable”</h4>
                    <p>
                        <img className="step-3-img" alt="arrow" src="./click-enable.jpg"></img>
                    </p>
                    <h4>4.Click on Notifications (this is optional)</h4>
                    <p>
                        <img className="step-3-img max-320" alt="arrow" src="./permissions.jpg"></img>
                    </p>
                    <h4>5. Link the Alexa User</h4>
                    <div className="link-alexa-img-container">
                        <img className="step-3-img  max-320" alt="arrow" src="./link-account.jpg"></img>
                        <img className="step-3-img  max-320" alt="arrow" src="./enter-s2-account.jpg"></img>
                    </div>
                    <Popup
                        trigger={<Icon name="question circle" className="question-icon" />}
                        position="top center"
                        hoverable
                        flowing
                    >
                        <div className="signup-popup-content step-3">
                            <p>
                                This step connects the Alexa User to their Speak2 Account. It’s called “Account
                                Linking”. There are a few steps to follow. The goal is to make sure the Alexa device is
                                connected to the right person, and that person is connected to you.  Here is how it
                                works. Go to the Amazon account for the Alexa User and log in.
                            </p>
                            <p>
                                A common error is to log into the wrong Amazon account - be sure to log into the account
                                that the Alexa is connected with. This is not your personal account.
                            </p>
                            <p>
                                Once you’re logged in, search for the Speak2 Family skill, or click this link
                                <a href="https://www.amazon.com/Speak2-Software-Family/dp/B085DP2587">
                                    https://www.amazon.com/Speak2-Software-Family/dp/B085DP2587
                                </a>{' '}
                                - then, click Enable.
                            </p>
                            <p>
                                Please enable notifications. This is optional but critical so the Alexa User can see
                                when someone has left a message or is following up on a Request.
                            </p>
                            <p>
                                Next, click “Link Account”. This is the key step. Enter the Speak2 Family account you
                                set up for the Alexa User in Step 2. These are the credentials you wrote down.
                            </p>
                            <p>
                                Once you do this, you’re all set and ready to use Speak2 Family. The Alexa User can
                                start using it by saying “Alexa, open Speak2” and then say what you want - “Alexa, open
                                Speak2…..send a message….hello, this is Jillian….”
                            </p>
                        </div>
                    </Popup>
                </div>
            </div>
        );
    };

    return (
        <div>
            <div className="header step-3">LAST STEP: LINK ALEXA TO SPEAK2</div>
            <div className="content">
                <div className="content-row pb-70">
                    <div className="">
                        <div className="info">
                            <div className="icon-section">
                                <span className="item-number circle">3</span>
                            </div>
                            <div>
                                <h3 className="info-title">
                                    You’ll need to connect the Alexa User you set up in Step 2 to their Amazon Alexa
                                    account. This is to “link” the Alexa Smart Speaker to Speak2 so your interactions
                                    are connected, private, and secure. If you need help, please contact Support below
                                    and we can walk you through it. You can connect Alexa skill in the web, or in your
                                    Alexa app.
                                </h3>
                                {window.innerWidth < 600 && imageSection()}
                            </div>
                        </div>
                        <Accordion>
                            <Accordion.Title active={accordianIndex === 1} index={1} onClick={handleClick}>
                                <Icon name="dropdown" />
                                Help
                            </Accordion.Title>
                            <Accordion.Content active={accordianIndex === 1}>
                                <div className="info ">
                                    <div className="icon-section"></div>
                                    <div className="embed-container">
                                        <ReactPlayer
                                            url="https://vimeo.com/462664753"
                                            config={{
                                                vimeo: {
                                                    playerOptions: {
                                                        id: '462664753',
                                                        controls: true,
                                                    },
                                                },
                                            }}
                                        ></ReactPlayer>
                                    </div>
                                </div>
                                <ScheduleCall />
                                <PrintInstructions />
                            </Accordion.Content>
                        </Accordion>
                        <div className="info">
                            <div className="icon-section"></div>
                            <div>
                                <Button onClick={props.nextStep} primary>
                                    Next
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div>{window.innerWidth > 600 && imageSection()}</div>
                </div>
            </div>
        </div>
    );
};

const Fourth = (props) => {
    const [accordianIndex, setAccordianIndex] = useState(window.innerWidth > 600 ? 1 : -1);
    const history = useHistory();

    const handleClick = (e, titleProps) => {
        const { index } = titleProps;
        const newIndex = accordianIndex === index ? -1 : index;
        setAccordianIndex(newIndex);
    };

    const imageSection = () => {
        return (
            <div className="flex flex-justify-center">
                <div className="image-container">
                    <img className="link-to-alexa-img" src="./speak2-mobile-feed.png" alt="" />
                </div>
            </div>
        );
    };

    const handleGoToWebsiteButtonClick = async () => {
        callAndroidHandler(props.credentials.contact, props.credentials.password);
        callAppleHandler(props.credentials.contact, props.credentials.password);
        await props.reloadRegistrantLists();
        history.push('/');
    };

    return (
        <div>
            <div className="header step-1">THAT’S IT - YOU ARE READY TO GO!</div>
            <div className="content">
                <div className="content-row">
                    <div className="">
                        <div className="info">
                            <div className="icon-section">
                                <span className="item-number circle">4</span>
                            </div>
                            <div>
                                <h3 className="info-title">
                                    The Alexa can now be used to send messages, create requests, or record activities.
                                    You will see this in the Speak2 Family app. Below are some resources for more help,
                                    and check out our website to learn even more!
                                </h3>
                                {window.innerWidth < 600 && imageSection()}
                            </div>
                        </div>
                        <Accordion>
                            <Accordion.Title active={accordianIndex === 1} index={1} onClick={handleClick}>
                                <Icon name="dropdown" />
                                Help
                            </Accordion.Title>
                            <Accordion.Content active={accordianIndex === 1}>
                                <div className="info ">
                                    <div className="icon-section"></div>
                                    <div className="embed-container">
                                        <ReactPlayer
                                            url="https://vimeo.com/406354326"
                                            config={{
                                                vimeo: {
                                                    playerOptions: {
                                                        id: '406354326',
                                                        controls: true,
                                                    },
                                                },
                                            }}
                                        ></ReactPlayer>
                                    </div>
                                </div>
                                <ScheduleCall />
                                <PrintInstructions />
                            </Accordion.Content>
                        </Accordion>
                        <div className="info">
                            <div className="icon-section"></div>
                            <div>
                                <Button role="link" primary onClick={handleGoToWebsiteButtonClick}>
                                    Go to Website
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div>{window.innerWidth > 600 && imageSection()}</div>
                </div>
            </div>
        </div>
    );
};

export default Signup;
